<template>
  <span v-if="disabled">
    <slot />
  </span>
  <a v-else-if="isV1Legacy" :href="to">
    <slot />
  </a>
  <RouterLink v-else :to="to">
    <slot />
  </RouterLink>
</template>

<script lang="ts">
import { isLegacyRoute } from "@/router/legacyRutes";
import { isV1Legacy } from "@/state/appState";
import { defineComponent } from "vue";
import { RouterLink } from "vue-router";

export default defineComponent({
  components: { RouterLink },
  props: { 
    to: { type: String, default: "" },
    disabled: { type: Boolean, default: false }, 
  },
  computed: {
    isV1Legacy(): boolean {
      if (isLegacyRoute(this.to)) {
        return true;
      }
      return isV1Legacy.value;
    },
  },
});
</script>
